<template>
  <div>
        <!--登录表单-->
        <el-form :inline="true" :model="formData" :rules="rules" ref="formData" class="full-form" :hide-required-asterisk="true" label-width="80px">
            <el-form-item  label="当前销售" v-if="changeUseItem.truename">
                {{changeUseItem.truename}}
            </el-form-item>
            <el-form-item label="销售职位" prop="position_name">
                <el-select v-model="formData.position_name" placeholder="请选择职位">
                    <el-option v-for="item in $GVAR.position" :key="item.id" :label="item.name" :value="item.name" ></el-option>
                </el-select>
            </el-form-item>
            <el-button class="mt-3" type="primary" style="width: 100%;" @click="submitForm('formData')"  block>确认更改</el-button>
        </el-form>
  </div>
</template>

<script>
import { mapState,mapGetters,mapActions} from 'vuex'
export default {
  name: 'ChangePosition',
  components: {},
  props: {
    changeUseItem: {
      type:Object,
      default:()=>{}
    },
    changeStoreid: {
      type:Number,
      default:0
    }
  },
  data() {
    return {
        formData:{
            store_id:'',
            uid:'',
            position_name:'',
        },
        rules: {  
            position_name: [
                { required: true, message: '请选择职位', trigger: 'blur' },
            ],  
      },
    };
  },
  computed: {},
  watch: {
    changeUseItem:{
        handler(newVal,oldVal){
            console.log(newVal)
            this.formData.position_name = newVal.position_name||'';
        },
        immediate:true
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['POST_SetUserStorePositionName']),
        // 添加验证表单
        async submitForm(formName) {
        await this.$refs[formName].validate(async valid => {
            if (valid) {
                // 提交表单数据
                this.formData.store_id = this.changeStoreid;
                this.formData.uid = this.changeUseItem.uid||'';
                this.POST_SetUserStorePositionName({data:this.formData,successFun:()=>{
                    this.$emit('changeSuccess',this.changeUseItem,this.formData.position_name)
                }})
            } else {    
            return false;
            }
        });
        },
    }
};
</script>

<style lang="scss" scoped>
    .full-form{
        display: flex;
        flex-direction: column; 
    }
</style>

<style>
    .full-form .el-form-item__content{
        width: 81%;
    }
    .full-form .el-select{
        width: 100%;
    }
</style>
